import React from "react";
import Layout from "../hocs/Layout";
import {connect} from "react-redux";
import Hero from "../components/home/hero";
import Download from "../components/home/download";
import Plans from "../components/home/plans";
import Service from "../components/home/service";
import Contract from "../components/home/contract";
import VerticalSlider from "../components/home/slider";
import Question from "../components/home/question";
import Footer from "../components/navigation/Footer";
import Whatsapp from "../widgets/whatsapp";



const Home = ({strellatv}) => {
    return (
        <Layout>
            {strellatv &&
                (
                    <>
                        <Hero/>
                        <Download data={strellatv} />
                        <Plans/>
                        <Service/>
                        <Contract/>
                        <VerticalSlider/>
                        <Question/>
                        <Footer/>
                        <Whatsapp/>
                    </>
                )
            }

        </Layout>
    );
};


const mapStateToProps = state => ({
    strellatv: state.Home.strellatv,
})

export default connect(mapStateToProps, {})(Home)
